<template>
    <div class="container" style="height:100%;">
        <div class="splash__screen-wrapper d-flex align-items-center">
            <div class="tab-content w-100">
                <div
                    class="tab-pane fade"
                    :class="{'show active': step === 1}"
                >
                    <div class="flex-fill">
                        <div class="row justify-content-center pt-5" style="padding-bottom: 80px;">
                            <div class="col-md-6">
                                <div class="splash__screen-image-content">
                                    <div>
                                        <div class="wfh-title">
                                            Hi {{ user.display_name || user.name }}, {{greeting}}
                                        </div>
                                        <div class="wfh-paragraph-md">Ready to start working?</div>
                                    </div>
                                    <img
                                        class="splash__screen-image-content-img"
                                        src="/images/check-in.png"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="h-100 d-flex">
                                    <div style="flex:1;">
                                        <div class="wfh-tab-header mt-2">Recent Check-ins</div>
                                        <div class="mt-4">
                                            <recent-staff-activity-list
                                                :activityRecord="activityRecord"
                                                :timezone="timezone"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="height: 120px"></div>
                        <actions-fab
                            :photoCheckin="isPhotoCheckin"
                            @doPhotoCheckin="doPhotoCheckin"
                        ></actions-fab>
                    </div>
                </div>
                <div
                    class="tab-pane fade"
                    :class="{'show active': step === 2}"
                >
                    <div class="mt-5 mb-0 ml-auto mr-auto d-flex justify-content-center flex-column align-items-center">
                        <h1 class="action-title mb-4">Take your selfie</h1>

                        <Loader v-if="!streaming"></Loader>

                        <div class="d-flex justify-content-center position-relative">
                            <video ref="video" playsinline></video>
                            <button class="btn custom-btn position-absolute" type="button" @click="takePicture"
                                    v-show="streaming">
                                <img src="/images/Camera.svg" alt="Camera Icon">
                            </button>
                        </div>
                    </div>
                </div>
                <div
                    class="tab-pane fade"
                    :class="{'show active': step === 3}"
                >
                    <div class="mt-5 mb-0 ml-auto mr-auto d-flex justify-content-center flex-column align-items-center">
                        <h1 class="action-title mb-4">Take your selfie</h1>

                        <div>
                            <canvas ref="previewCanvas" hidden></canvas>
                            <div class="output">
                                <img ref="selfiePreview" alt="The screen capture will appear in this box.">
                            </div>
                        </div>

                        <div class="text-center w-100 mt-3 mb-3">
                            <h4 class="selfie-title">Continue check-in with this photo?</h4>
                            <p class="selfie-text">Is this your most awesome seflie? Make it your profile pictiure :-)</p>
                        </div>

                        <div class="selfie-action mb-5 d-flex justify-content-center align-items-center">
                            <button type="button" class="btn wfh-btn-primary-outline" @click="doPhotoCheckin">Retake</button>
                            <button
                                type="button"
                                class="btn wfh-btn-primary position-relative"
                                @click="checkIn"
                                :disabled="submitting"
                            >
                                <span
                                    class="spinner-border position-absolute"
                                    role="status"
                                    style="left: 8px;top: 8px;height: 34px;width: 34px;"
                                    v-if="submitting"
                                >
                                    <span class="sr-only">Loading...</span>
                                </span>
                                Continue
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {blobToFile} from '../../ImageCompressor';
    import Loader from '../Misc/Loader';

    export default {
        components: { Loader },
        data() {
            return {
                status: {},
                user: {},
                activityRecord: [],
                limit: 6,
                timezone: null,
                camPlayback: null,
                previewCanvas: null,
                previewHeight: 450,
                previewWidth: 600,
                video: null,
                previewPhoto: null,
                stream: null,
                step: 1,
                streaming: false,
                loading: false,
                submitting: false,
            };
        },

        computed: {
            greeting() {
                const currentHour = (new Date()).getHours();

                return currentHour < 12 ? 'Good Morning!' :
                    currentHour < 18 ? 'Good Afternoon!' :
                        'Good Evening!';
            },

            isPhotoCheckin() {
                if (this.user.company) {
                    return this.user.company.photo_checkin;
                }

                return false;
            }
        },

        methods: {
            async checkIn() {
                try {
                    this.loading = true;
                    this.submitting = true;

                    const photo = await fetch(this.previewPhoto).then(res => res.blob());
                    const imageFile = blobToFile(photo, 'Selfie Image');
                    let formData = new FormData();

                    formData.append('status', 'check_in');
                    formData.append('selfie_image', imageFile);

                    await axios.post("/user-availability-log", formData);

                    location.href = '/dashboard';
                } catch (e) {
                    this.loading = false;
                    this.step = 1;
                }
            },

            updateStreaming() {
                this.streaming = !this.streaming;
            },

            async doPhotoCheckin() {
                this.video = this.$refs.video;
                let vid = this.$refs.video;
                this.step = 2;

                if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                    try {
                        const stream = await navigator.mediaDevices.getUserMedia({ video: true, facingMode: 'user' });
                        this.stream = stream;
                        vid.srcObject = stream;
                        vid.play();

                        vid.addEventListener('playing', this.updateStreaming);
                    } catch (err) {
                        this.step = 1;
                        alert('You must allow camera to be able to check-in.');
                    }
                }
            },

            takePicture () {
                this.updateStreaming();
                this.step = 3;
                this.previewCanvas = this.$refs.previewCanvas;
                var context = this.$refs.previewCanvas.getContext('2d');

                this.previewCanvas.width = this.video.videoWidth;
                this.previewCanvas.height = this.video.videoHeight;
                context.drawImage(this.video, 0, 0, this.video.videoWidth, this.video.videoHeight);

                const data = this.previewCanvas.toDataURL('image/png');
                this.$refs.selfiePreview.setAttribute('src', data);
                this.previewPhoto = data;

                const tracks = this.stream.getTracks();

                tracks.forEach(function(track) {
                    track.stop();
                });
            },

            async fetchTimezone() {
              const res = await axios.get("/me");

              this.timezone = res.data?.data?.office_timezone?.zone_name || null;
            },

            async getUser() {
                this.user = await axios.get("/me").then(data => data.data.data);
            },

            async getActivityRecord() {
              const res = await axios.get(`/company/users-availability-list?limit=${this.limit}`);

              this.activityRecord = res.data.data;
            }
        },

        mounted() {
          const urlParams = new URLSearchParams(window.location.search);

          this.getUser();
          this.fetchTimezone();
          this.getActivityRecord();

          if (parseInt(urlParams.get('step')) === 2) {
            this.step = 2;
            this.doPhotoCheckin();
          }
        }
    };
</script>

<style lang="scss">
.custom-btn {
    bottom: 16px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #EF6B59;
    align-items: center;
    display: flex;
    justify-content: center;
}
.action-title {
    color: #303030;
    font-family: Lato;
    font-size: 38px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 53.2px;
}
.selfie-title {
    color: #333333 !important;
    font-family: "Open Sans" !important;
    font-size: 18px !important;
    font-weight: bold !important;
    letter-spacing: 0 !important;
    line-height: 24px !important;
}
.selfie-text {
    color: #808FA4 !important;
    font-family: "Open Sans" !important;
    font-size: 14px !important;
    letter-spacing: 0 !important;
    line-height: 20px !important;
    text-align: center !important;
}
.selfie-action {
    button {
        width: 220px !important;
        height: 48px !important;
        min-height: 48px !important;
    }

    button:first-child {
        margin-right: 8px;
    }
}
video {
    max-width: 100vw;
}
</style>
